import { render, staticRenderFns } from "./BookingListSideMenu.vue?vue&type=template&id=381b9d65&scoped=true"
import script from "./BookingListSideMenu.vue?vue&type=script&lang=js"
export * from "./BookingListSideMenu.vue?vue&type=script&lang=js"
import style0 from "./BookingListSideMenu.vue?vue&type=style&index=0&id=381b9d65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381b9d65",
  null
  
)

export default component.exports